import { APP_NAME, WELCOME_MESSAGE, PLANNER_APP_NAME, PLANNER_WELCOME_MESSAGE } from "../env.js";

export const salesConfig = {
  title: APP_NAME,
  welcomeMessage: WELCOME_MESSAGE,
  primaryColor: "#5425AF",
  secondaryColor: "#812C90",
  initialMessage: null,
  hideInitialMessageFromHistory: false,
};

export const plannerConfig = {
  title: PLANNER_APP_NAME,
  welcomeMessage: PLANNER_WELCOME_MESSAGE,
  primaryColor: "#1565C0",
  secondaryColor: "#0D47A1",
  initialMessage: "/plan",
  hideInitialMessageFromHistory: true,
};
